import React from 'react'
import { atom, useAtom } from 'jotai'

import { Button } from '@mui/material'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ForgotPassword from './forgotPassword'
import ChangePassword from './changePassword'
import OTPVerification from './otpVerification'
import VerifyAccount from './verifyAccount'
import EmailInput from '../customInputFields/emailInput'
import PasswordInput from '../customInputFields/passwordInput'

import { loginLabels } from 'utils/labels'
import { EMAIL_REGEX } from 'utils/regex'
import { accountStatusAtom } from 'constants/atoms'

const phoneNumberAtom = atom('')
const modeAtom = atom('')
const otpAtom = atom('')

const LoginForm = ({ handleChange, loginInputData, onLogin }) => {
  const { inputEmail = '', inputPassword = '' } = loginInputData
  const [accountStatus, setAccountStatus] = useAtom(accountStatusAtom)
  const [phoneNumber, setPhoneNumber] = useAtom(phoneNumberAtom)
  const [mode, setMode] = useAtom(modeAtom)
  const [otp, setOtp] = useAtom(otpAtom)

  const invalidEmail = inputEmail ? !EMAIL_REGEX.test(inputEmail) : false
  const invalidPassword = !inputPassword

  const disableSignInBtn =
    invalidEmail || invalidPassword || !inputPassword || !inputEmail

  return (
    <div>
      <div className="avatarIconWrap">
        <AccountCircleIcon className="avatarDiv" />
      </div>
      {accountStatus === 'default' && (
        <div className="loginStep1Wrap divBox">
          <p className="loginNormalText">{loginLabels.loginStep1Label()}</p>
          <EmailInput
            value={inputEmail}
            showAdornment={false}
            handleChange={({ target }) =>
              handleChange('inputEmail', target.value)
            }
          />
          <PasswordInput
            value={inputPassword}
            showAdornment={false}
            onChange={({ target }) =>
              handleChange('inputPassword', target.value)
            }
            onKeyDown={(event) =>
              event.key === 'Enter' && !disableSignInBtn && onLogin()
            }
          />
          <Button
            fullWidth
            size="large"
            color="success"
            variant="contained"
            onClick={() => onLogin()}
            disabled={disableSignInBtn}
          >
            Sign In
          </Button>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span
              style={{
                paddingTop: '10px',
                paddingLeft: '10px',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => setAccountStatus('forgotPassword')}
            >
              Forgot Password?
            </span>
            <Button
              href={
                window.location.href.includes('tow.copart.com')
                  ? 'https://vendor-connect.copart.com/register?source=LDFRM'
                  : 'https://c-vendor-connect-qa4.copart.com/register?source=LDFRM'
              }
              target="_blank"
            >
              Register
            </Button>
          </div>
        </div>
      )}
      {accountStatus === 'forgotPassword' && (
        <ForgotPassword inputEmail={inputEmail} handleChange={handleChange} />
      )}
      {accountStatus === 'verifyAccount' && (
        <VerifyAccount
          phoneNumber={phoneNumber}
          inputEmail={inputEmail}
          handleChange={handleChange}
          invalidEmail={invalidEmail}
          setMode={setMode}
          setPhoneNumber={setPhoneNumber}
        />
      )}
      {accountStatus === 'otpVerification' && (
        <OTPVerification
          mode={mode}
          phoneNumber={phoneNumber}
          inputEmail={inputEmail}
          otp={otp}
          setOtp={setOtp}
        />
      )}
      {accountStatus === 'changePassword' && (
        <ChangePassword otp={otp} setOtp={setOtp} />
      )}
    </div>
  )
}

export default LoginForm
